import "./instrument";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import TagManager from 'react-gtm-module'
import configureStore from './configureStore';
import App from './App';
import config from "./config";
import './i18n';

if(config.gtm) TagManager.initialize({gtmId: config.gtm})

const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store} >
        <App />
    </Provider>
);